import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        light1Green : '#81C784',

        blue: '#0096e0',
        light1Blue: '#42A5F5',
        light2Blue: '#90CAF9',
        deepBlue: '#2E6AA3',

        red: '#ed3843',
        light1Red: '#f87979',

        grey: '#454a4d',
        light1Grey: '#BDBDBD',
        light2Grey: '#9E9E9E',
        dark3Grey: '#424242',

        white: '#ffffff',
        navy: '#292E42',

        orange: '#ffb35e',
        lightOrange: '#ffb767',
        deepOrange: '#fb8502',

        yellow: '#f7b632',
        namuMint: '#8c78ff',
      },
      dark: {
        light1Green : '#81C784',

        blue: '#0096e0',
        light1Blue: '#42A5F5',
        light2Blue: '#90CAF9',

        red: '#ed3843',
        light1Red: '#f87979',

        grey: '#454a4d',
        light1Grey: '#BDBDBD',
        light2Grey: '#9E9E9E',
        dark3Grey: '#424242',

        white: '#ffffff',
        navy: '#292E42',

        orange: '#ffb35e',
        lightOrange: '#ffb767',
        deepOrange: '#fb8502',

        yellow: '#f7b632',
        namuMint: '#3accba',
      },
    },
  }
});
